const motionAssetBasePath = '/assets/motions/'

/** VRMA の source 文字列を、GLTFLoader が読めるパスへ解決する。 */
export const resolveVrmaFilePath = (source: string): string => {
  const file = source.trim()
  if (!file) return ''

  if (
    file.startsWith('blob:') ||
    file.startsWith('http://') ||
    file.startsWith('https://') ||
    file.startsWith('data:') ||
    file.startsWith('/')
  ) {
    return file
  }

  return `${motionAssetBasePath}${file}`
}
